<template>
  <div class="ethnien">
    <Header
      :pageTitle = "navigation.ethnografies.headerTitle[lang]"
      schema="default"
    />
    <b-container class="pb-1">
      <Breadcrumb
        :pathToPage="pathToThisPage"
      />
      <!-- <b-row>
        <b-col>
          <b-tabs content-class="mt-3" justified>
            <b-tab title="First" active><p>I'm the first tab</p></b-tab>
            <b-tab title="Second"><p>I'm the second tab</p></b-tab>
            <b-tab title="Very, very long title"><p>I'm the tab with the very, very long title</p></b-tab>
          </b-tabs>
        </b-col>
      </b-row> -->
      <b-row>
        <b-col
          md="12"
        >
          <div
          v-if="pageData.body && ethnoGroupsData"
          v-html="normalize(pageData.body)"
          class="lead lead-box mb-4"
        />
        </b-col>
        <b-col
          sm=12
        >
        <EthnicCommunitiesMap :ethnosData="ethnosData"/>
        </b-col>
        <b-col
          md="4"
        >
          <b-list-group class="mb-3"
            v-if="ethnoGroupsData"
          >
            <b-list-group-item><strong>{{ ethnoGroupTitle('voelker-mit-uralischen-sprachen') }}</strong></b-list-group-item>
            <b-list-group-item
              v-for="(ethno, index) in ethnosOfGroup('voelker-mit-uralischen-sprachen')"
              :key="index"
              :class="{ 'ethnie-active': !ethno.nurName }"
            >
              <template
                v-if="ethno.nurName"
              >
                {{ ethno.titel }}
              </template>
              <template
                v-else
              >
                <router-link
                tag="a"
                :to="`/ethnie/${ethno.slug}`"
                >
                  {{ ethno.titel }}
                </router-link>
              </template>
            </b-list-group-item>
          </b-list-group>
        </b-col>
        <b-col
          md="4"
        >
          <b-list-group class="mb-3"
            v-if="ethnoGroupsData"
          >
            <b-list-group-item><strong>{{ ethnoGroupTitle('turksprachige-voelker') }}</strong></b-list-group-item>
            <b-list-group-item
              v-for="(ethno, index) in ethnosOfGroup('turksprachige-voelker')"
              :key="index"
              :class="{ 'ethnie-active': !ethno.nurName }"
            >
              <template
                v-if="ethno.nurName"
              >
                {{ ethno.titel }}
              </template>
              <template
                v-else
              >
                <router-link
                tag="a"
                :to="`/ethnie/${ethno.slug}`"
                >
                  {{ ethno.titel }}
                </router-link>
              </template>
            </b-list-group-item>
          </b-list-group>
        </b-col>
        <b-col
          md="4"
        >
          <b-list-group class="mb-3"
            v-if="ethnoGroupsData"
          >
            <b-list-group-item><strong>{{ ethnoGroupTitle('voelker-der-nordamerikanischen-arktis') }}</strong></b-list-group-item>
            <b-list-group-item
              v-for="(ethno, index) in ethnosOfGroup('voelker-der-nordamerikanischen-arktis')"
              :key="index"
              :class="{ 'ethnie-active': !ethno.nurName }"
            >
              <template
                v-if="ethno.nurName"
              >
                {{ ethno.titel }}
              </template>
              <template
                v-else
              >
                <router-link
                tag="a"
                :to="`/ethnie/${ethno.slug}`"
                >
                  {{ ethno.titel }}
                </router-link>
              </template>
            </b-list-group-item>
          </b-list-group>
        </b-col>
        <b-col
          md="4"
        >
          <b-list-group class="mb-3"
            v-if="ethnoGroupsData"
          >
            <b-list-group-item><strong>{{ ethnoGroupTitle('tungusischsprachige-voelker') }}</strong></b-list-group-item>
            <b-list-group-item
              v-for="(ethno, index) in ethnosOfGroup('tungusischsprachige-voelker')"
              :key="index"
              :class="{ 'ethnie-active': !ethno.nurName }"
            >
              <template
                v-if="ethno.nurName"
              >
                {{ ethno.titel }}
              </template>
              <template
                v-else
              >
                <router-link
                tag="a"
                :to="`/ethnie/${ethno.slug}`"
                >
                  {{ ethno.titel }}
                </router-link>
              </template>
            </b-list-group-item>
          </b-list-group>
        </b-col>
        <b-col
          md="4"
        >
          <b-list-group class="mb-3"
            v-if="ethnoGroupsData"
          >
            <b-list-group-item><strong>{{ ethnoGroupTitle('voelker-mit-palaeoasiatischen-sprachen') }}</strong></b-list-group-item>
            <b-list-group-item
              v-for="(ethno, index) in ethnosOfGroup('voelker-mit-palaeoasiatischen-sprachen')"
              :key="index"
              :class="{ 'ethnie-active': !ethno.nurName }"
            >
              <template
                v-if="ethno.nurName"
              >
                {{ ethno.titel }}
              </template>
              <template
                v-else
              >
                <router-link
                tag="a"
                :to="`/ethnie/${ethno.slug}`"
                >
                  {{ ethno.titel }}
                </router-link>
              </template>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
    </b-container>
  </div><!-- .homepage -->
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Header from '@/components/Header.vue'
import EthnicCommunitiesMap from '@/components/subparts/Ethnic-communities-map.vue'
import Breadcrumb from '@/components/subparts/Breadcrumb-subpart.vue'
import initView from '../mixins/initView'

export default {
  name: 'ethnien',
  data () {
    return {
      hbg: '',
      gruppen: ['g1', 'g2'],
      slug: 'ethnien'
    }
  },
  components: {
    Header,
    EthnicCommunitiesMap,
    Breadcrumb
  },
  mixins: [
    initView
  ],
  methods: {
    ...mapActions({

    }),
    fetchData () {
      this.slug = this.$route.params.page
    },
    ethnoGroupTitle (slug) {
      let titel = ''
      titel = this.ethnoGroupsData.find(eg => eg.slug === slug).titel
      return titel
    },
    ethnosOfGroup(ethnoTitle) {
      let ethnoIds = this.ethnoGroupsData
        .find(eg => eg.slug === ethnoTitle).ethnos
        .map(e => e.id)
      let groupEthnos = this.ethnosData
        .filter(e => ethnoIds.includes(e.id))
        .map(e => {
          return {
            titel: e.titel,
            kennnummer: e.kennnummer,
            slug: e.slug,
            nurName: e.nurName
          }
        })
      return groupEthnos
    }
  },
  computed: {
    ...mapGetters({
      lang: 'getLanguage',
      navigation: 'getNavigation',
      ethnosData: 'getEthnosData',
      ethnoGroupsData: 'getEthnoGroupsData',
      newRoute: 'getNewRoute'
      // ethnoGroupDataForGroup: 'getEthnoGroupDataForGroup'
    }),
    pathToThisPage () {
      let path = []
      let nav = this.$store.state.navigation
      let lang = this.$store.state.lang

      path[0] = {
        name: nav.home.navTitle[lang],
        slug: '/',
        disabled: false
      }
      path[1] = {
        name: nav.allEthnografies.navTitle[lang],
        slug: '',
        disabled: true
      }
      return path
    },
    pageData () {
      if (this.$store.state.pagesData.de) {
        return this.$store.getters.getPageData('ethnien')[0]
      } else {
        return ''
      }
    }
  },
  created () {
    this.$store.dispatch('fetchApiEthnoGroupsData')
    // this.fetchData()
  },
  watch: {
    // call again the method if the route changes
    '$route': 'fetchData'
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>

}
